import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "tw-mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "sf-form-group tw-pb-4 md:tw-grid md:tw-grid-cols-2 md:tw-gap-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, " Select the country where your school is located ", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "sf-form-group tw-pb-4 md:tw-grid md:tw-grid-cols-2 md:tw-gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "tw-block" }, " Your reference / PO Number "),
  /*#__PURE__*/_createTextVNode(" (Optional) ")
], -1)
const _hoisted_11 = {
  key: 3,
  class: "sf-form-group tw-pb-4 md:tw-grid md:tw-grid-cols-2 md:tw-gap-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_13 = { class: "tw-flex tw-justify-end" }
const _hoisted_14 = { class: "sf-table tw-text-right" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "Spelling classes", -1)
const _hoisted_16 = { class: "tw-text-right" }
const _hoisted_17 = { class: "tw-text-right" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Maths classes", -1)
const _hoisted_20 = { class: "tw-text-right" }
const _hoisted_21 = { class: "tw-text-right" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Spelling + Maths class discount", -1)
const _hoisted_24 = { class: "tw-text-right" }
const _hoisted_25 = { class: "tw-text-right" }
const _hoisted_26 = { class: "tw-font-bold" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "Total cost before VAT", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_29 = { class: "tw-text-right" }
const _hoisted_30 = { class: "tw-text-danger tw-font-bold tw-mt-2" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchoolActivationPeriod = _resolveComponent("SchoolActivationPeriod")!
  const _component_SchoolActivationClassesField = _resolveComponent("SchoolActivationClassesField")!

  return (_ctx.classCostData != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mode == 'activation')
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Account Activation"))
          : (_ctx.mode == 'addclasses')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "Add Classes"))
            : (_ctx.mode == 'extend')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "Subscription Renewal"))
              : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.classCostData)
            ? (_openBlock(), _createBlock(_component_SchoolActivationPeriod, {
                key: 0,
                "spelling-period": _ctx.classCostData.subscriptions.spelling.period,
                "maths-period": _ctx.classCostData.subscriptions.maths.period
              }, null, 8, ["spelling-period", "maths-period"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          (_ctx.showCountryField)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.countryCode) = $event)),
                  class: "sf-form-control tw-w-full"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id,
                      value: c.countryCode
                    }, _toDisplayString(c.countryName), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.countryCode]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schoolReference) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.schoolReference]
              ])
            ])
          ]),
          (_ctx.classCostData?.availableTrial?.type != 'spelling')
            ? (_openBlock(), _createBlock(_component_SchoolActivationClassesField, {
                key: 1,
                subject: "spelling",
                mode: _ctx.mode,
                "class-cost": _ctx.spellingClassCost,
                "current-subscription-class-count": _ctx.currentSpellingClassCount,
                modelValue: _ctx.spellingClassCount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.spellingClassCount) = $event))
              }, null, 8, ["mode", "class-cost", "current-subscription-class-count", "modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.mathsAvailable && _ctx.classCostData?.availableTrial?.type != 'maths')
            ? (_openBlock(), _createBlock(_component_SchoolActivationClassesField, {
                key: 2,
                subject: "maths",
                mode: _ctx.mode,
                "class-cost": _ctx.mathsClassCost,
                "current-subscription-class-count": _ctx.currentMathsClassCount,
                modelValue: _ctx.mathsClassCount,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mathsClassCount) = $event))
              }, null, 8, ["mode", "class-cost", "current-subscription-class-count", "modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.classCostData?.availableTrial)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activateTrial) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.activateTrial]
                  ]),
                  _createTextVNode(" Activate " + _toDisplayString(_ctx.classCostData.availableTrial.type) + " " + _toDisplayString(_ctx.classCostData.availableTrial.length) + " days trial ", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_15,
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.spellingClassCount) + " x " + _toDisplayString(_ctx.$filters.renderMoney(_ctx.spellingClassCost)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$filters.renderMoney(_ctx.spellingClassCost * _ctx.spellingClassCount)), 1)
                ]),
                (_ctx.mathsAvailable)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.mathsClassCount) + " x " + _toDisplayString(_ctx.$filters.renderMoney(_ctx.mathsClassCost)), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$filters.renderMoney(_ctx.mathsClassCost * _ctx.mathsClassCount)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mathsAvailable)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.comboCount) + " x " + _toDisplayString(_ctx.$filters.renderMoney(_ctx.comboDiscount)), 1),
                      _createElementVNode("td", _hoisted_25, " -" + _toDisplayString(_ctx.$filters.renderMoney(_ctx.totalDiscount)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_26, [
                  _hoisted_27,
                  _hoisted_28,
                  _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.$filters.renderMoney(_ctx.totalCost)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_30, [
              (_ctx.showMinClassesError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, " At least 1 class is required "))
                : _createCommentVNode("", true),
              _createTextVNode("   ")
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.showMinClassesError,
              class: "sf-btn-primary"
            }, [
              (_ctx.mode == 'activation')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Activate ")
                  ], 64))
                : (_ctx.mode == 'addclasses')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Add Classes ")
                    ], 64))
                  : (_ctx.mode == 'extend')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" Renew ")
                      ], 64))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_32)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}